import React from 'react';
import { Gradient } from '../Gradient';

const Extension = ({ type, className = '', color = '#737373' }) => {
  return (

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M1.95027 11.4592C3.90648 14.8475 8.23903 16.0084 11.6273 14.0522C13.1888 13.1506 14.2773 11.7444 14.8055 10.1584C14.8805 9.93335 14.7341 9.6998 14.5015 9.65366L12.3721 9.23148C11.9589 9.14956 11.558 9.39518 11.3511 9.76215C11.0325 10.3274 10.563 10.8172 9.96045 11.1651C8.16666 12.2008 5.87296 11.5862 4.83732 9.79239C3.80168 7.99861 4.41627 5.70491 6.21006 4.66927C6.2476 4.64759 6.28535 4.62664 6.32331 4.60641C6.6847 4.4138 6.93565 4.03479 6.87771 3.6294L6.56445 1.43787C6.53154 1.20762 6.30843 1.05376 6.08535 1.11959C5.55796 1.27521 5.04042 1.49515 4.54322 1.78222C1.15496 3.73843 -0.0059432 8.07098 1.95027 11.4592Z" 
 stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
<path d="M11.5871 6.5731C11.5175 6.39247 11.433 6.21491 11.3332 6.042C10.8785 5.25447 10.1813 4.69422 9.39041 4.40113C8.99158 4.25334 8.6839 3.89049 8.70437 3.46565L8.78685 1.75392C8.80991 1.27523 9.23289 0.910182 9.6995 1.01948C11.5382 1.45017 13.2015 2.61063 14.2202 4.37516C14.5867 5.00988 14.8438 5.67774 14.9973 6.3569C15.1062 6.83859 14.712 7.26334 14.2182 7.25797L12.4585 7.23881C12.0604 7.23447 11.7302 6.94459 11.5871 6.5731Z" 
 stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default Extension;